"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Log levels
 */
const CRITICAL = "critical";
const ERROR = "error";
const WARN = "warning";
const INFO = "information";
const VERBOSE = "verbose";
exports.logSeverity = {
    [CRITICAL]: 50,
    [ERROR]: 40,
    [WARN]: 30,
    [INFO]: 20,
    [VERBOSE]: 10,
};
exports.logLevels = {
    CRITICAL,
    ERROR,
    WARN,
    INFO,
    VERBOSE,
};
/**
 * Log sources
 */
const BROWSER_FUNCTION = "BrowserFunction";
const CLOUD_FUNCTION = "CloudFunction";
exports.logSources = {
    BROWSER_FUNCTION,
    CLOUD_FUNCTION,
};
/**
 * Component names
 */
const SESSION = "Session";
const DIALER = "Dialer";
const DASHBOARD = "Dashboard";
const AFTERCALL = "AfterCall";
const SUPERVISOR = "Supervisor";
exports.componentNames = {
    SESSION,
    DIALER,
    DASHBOARD,
    AFTERCALL,
    SUPERVISOR,
};
/**
 * Custom property keys
 */
const CHANNEL_SID = "ChannelSid";
const TASK_SID = "TaskSid";
const CALL_SID = "CallSid";
const WORKFLOW_SID = "WorkflowSid";
const WORKER_SID = "WorkerSid";
const WORKER_TASK_SID = "WorkerTaskSid";
const WORKER_RESERVATION_SID = "WorkerReservationSid";
const WORKER_ACTIVITY_SID = "WorkerActivitySid";
exports.customPropertyKeys = {
    CHANNEL_SID,
    TASK_SID,
    CALL_SID,
    WORKFLOW_SID,
    WORKER_SID,
    WORKER_TASK_SID,
    WORKER_RESERVATION_SID,
    WORKER_ACTIVITY_SID,
};
/**
 * Twilio action to log level mapping
 */
exports.twilioActionLogLevels = {
    AcceptTask: INFO,
    CancelTransfer: INFO,
    CompleteTask: INFO,
    HangupCall: INFO,
    HideDirectory: VERBOSE,
    HistoryGo: VERBOSE,
    HistoryGoBack: VERBOSE,
    HistoryGoForward: VERBOSE,
    HistoryPush: VERBOSE,
    HistoryReplace: VERBOSE,
    HoldCall: INFO,
    HoldParticipant: INFO,
    KickParticipant: INFO,
    Logout: INFO,
    MonitorCall: INFO,
    NavigateToView: INFO,
    RejectTask: INFO,
    SelectTask: INFO,
    SelectTaskInSupervisor: INFO,
    SelectWorkerInSupervisor: INFO,
    SendMessage: INFO,
    SendTyping: VERBOSE,
    SetActivity: INFO,
    SetInputText: VERBOSE,
    ShowDirectory: VERBOSE,
    StopMonitoringCall: INFO,
    ToggleMute: INFO,
    ToggleSidebar: VERBOSE,
    TransferTask: INFO,
    UnholdCall: INFO,
    UnholdParticipant: INFO,
    WrapupTask: INFO,
};
exports.twilioEventTypes = {
    TWILIO_TASK_ROUTER: "taskRouter",
    TWILIO_DEBUGGER: "debugger",
    TWILIO_CALL_STATUS: "callStatus",
};
/**
 * PII template tags
 */
exports.piiTags = {
    START: "_PII__",
    END: "__PII_",
};
//# sourceMappingURL=constants.js.map